import { useModelContext } from '@rhino-project/core/hooks';
import {
  getModelAndAttributeFromPath,
  getModelFromRef,
  isOwnerGlobal
} from '@rhino-project/core/utils';
import { ModelFilterBoolean } from './filters/ModelFilterBoolean';
import { ModelFilterDate } from './filters/ModelFilterDate';
import { ModelFilterDateTime } from './filters/ModelFilterDateTime';
import { ModelFilterEnum } from './filters/ModelFilterEnum';
import { ModelFilterFloat } from './filters/ModelFilterFloat';
import { ModelFilterInteger } from './filters/ModelFilterInteger';
import { ModelFilterIntegerSelect } from './filters/ModelFilterIntegerSelect';
import { ModelFilterOwnerReference } from './filters/ModelFilterOwnerReference';
import { ModelFilterReference } from './filters/ModelFilterReference';
import { ModelFilterString } from './filters/ModelFilterString';
import { ModelFilterTime } from './filters/ModelFilterTime';
import { ModelFilterYear } from './filters/ModelFilterYear';
import { useGlobalComponentForModel } from '@rhino-project/core/hooks';
import { RhinoResource } from '@rhino-project/core';

export interface ModelFilterProps {
  path: string;
  [key: string]: unknown;
}

export const ModelFilterBase = (props: ModelFilterProps) => {
  const { model } = useModelContext();
  const { path } = props;

  const [, attribute] = getModelAndAttributeFromPath(
    model as RhinoResource,
    path
  );

  // FIXME: Make this a separate function so that its easier to override
  switch (attribute?.type) {
    case 'boolean':
      return <ModelFilterBoolean {...props} />;
    case 'integer':
      switch (attribute.format) {
        case 'year':
          return <ModelFilterYear {...props} />;
        case 'select':
          return <ModelFilterIntegerSelect {...props} />;
        default:
          return <ModelFilterInteger {...props} />;
      }
    case 'number':
      return <ModelFilterFloat {...props} />;

    case 'reference': {
      const refModel = getModelFromRef(attribute!);

      if (isOwnerGlobal(refModel as RhinoResource))
        return <ModelFilterReference {...props} />;

      return <ModelFilterOwnerReference {...props} />;
    }
    case 'string':
      if (attribute?.enum) return <ModelFilterEnum {...props} />;

      switch (attribute.format) {
        case 'date':
          return <ModelFilterDate {...props} />;
        case 'time':
          return <ModelFilterTime {...props} />;
        case 'datetime':
          return <ModelFilterDateTime {...props} />;
        default:
          return <ModelFilterString {...props} />;
      }
    default:
      console.assert(false, 'No available filter for ', attribute);
  }

  return 'No filter for this attribute type';
};

export const ModelFilter = (props: ModelFilterProps) =>
  useGlobalComponentForModel('ModelFilter', ModelFilterBase, props);
